import { render, staticRenderFns } from "./TabTranscripcion.vue?vue&type=template&id=04b73fc0&scoped=true&"
import script from "./TabTranscripcion.vue?vue&type=script&lang=js&"
export * from "./TabTranscripcion.vue?vue&type=script&lang=js&"
import style0 from "./TabTranscripcion.vue?vue&type=style&index=0&id=04b73fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b73fc0",
  null
  
)

export default component.exports